import { MediaClient } from '@tier4/webauto-media-client';

export class CustomAudioDeviceManager implements MediaClient.AudioDeviceManager {
    async testAudioInput(): Promise<boolean> {
        try {
            await this.createStream();
            return true;
        } catch (e) {
            return false;
        }
    }

    async createStream() {
        return await navigator.mediaDevices.getUserMedia({
            video: false,
            audio: true,
        });
    }

    async playStream(stream: MediaStream) {
        const audio = new Audio();
        audio.srcObject = stream;
        await audio.play();
    }
}